export const auth = {
      title: 'Ingresa a {{appName}}',
      subtitle: 'Accede al panel administrativo.',
      cardTitle: 'Iniciar sesión',
      cardSubtitle: 'Autentícate con Microsoft Entra ID para entrar al sistema.',
      submit: 'Continuar con Microsoft',
      demoSubmit: 'Entrar a Demo (solo lectura)',
      createdBy: 'Creado por:',
      resumingButton: 'Completando inicio de sesión...',
      resumingSession: 'Estamos completando tu inicio de sesión con Microsoft Entra ID.',
      loginFailed: 'No fue posible iniciar sesión con Microsoft Entra ID.',
      accountSuspended: 'Tu acceso está suspendido. Contacta a un administrador para reactivarlo.',
      provider: 'Proveedor',
      providerValue: 'Microsoft Entra ID',
      providerHint: 'Acceso corporativo con inicio de sesión único.',
      providerBadge: 'SSO seguro',
      accessTitle: 'Acceso seguro',
      accessDescription: 'Usa tu cuenta corporativa para acceder al sistema de forma segura.',
    } as const;
